import React from 'react'
import { Redirect } from 'react-router-dom'
import Constants from '../data/constants'
import BrandPage from './brand'

export default function HomePage() {
    // console.log("HOME PAGE")
    return (
        // <BrandPage></BrandPage>
        <Redirect to="/login"></Redirect>
    )
}